import { useEffect, useRef } from 'react';
import { BACKEND_URL } from '../lib/config';
import { tokens } from '../lib/tokens';

// Subscribes to codex-level events (chapter created / patched). Calls
// onEvent(msg) with the raw message so the caller decides how to react.
export default function useCodexEvents(codexId, onEvent) {
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    if (!codexId) return undefined;
    const base = BACKEND_URL.replace(/^http/, 'ws');
    const ws = new WebSocket(
      `${base}/api/v1/codices/${codexId}/ws?access_token=${encodeURIComponent(
        tokens.access || ''
      )}`
    );
    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        cbRef.current?.(msg);
      } catch {
        /* ignore */
      }
    };
    return () => ws.close();
  }, [codexId]);
}
